module.exports = __webpack_public_path__ + "static/media/rapidsos_logo_light.bfec16ab.png";